// export const API = 'https://server.ronal2do.now.sh/graphql'
export const API = 'https://reciclabc.stqpublicidade.com.br/graphql'